export default "https://cdn-static-unstable.gokick.com/assets/b4100b98dde63e1c7260221a4305ac191c7ac51c/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";